import React from "react"
import uuid from "uuid"
import styled from "styled-components"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import get from "lodash/get"
import filter from "lodash/filter"
import isEmpty from "lodash/isEmpty"
import { translate } from "react-i18next"

import { event } from "../../components/reactGA"
import CarouselView from "../../components/carousel"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import ProductCard from "../../components/card/ProductCard"
import HowBid from "../HowBid"
import ExpenisonPanelView from "../../components/ExpenisonPanel"
import {
  fetchData,
  removeData,
  showToast,
  setHeaderTitle,
  saveData,
  showPopup,
  hidePopup,
} from "../../store/action"
import { replaceWithSymbol } from "../../util/cutString"
import config from "../../Config"
//import { ToasterMsg } from "../../site-settings";
import FreeBidPopup from "./FreeBidPopup"
import Storage from "../../util/Storage"
import Cookie from "../../util/Cookie"
import i18n from "../../i18n"
import CovidAlertPopup from "./CovidAlertPopup"
import StatsCard from "../../components/Stats/statsCard/StatsCard"
import Testimonial from "../../components/carousel/testimonial"
import HorizontalScroll from "../../components/horizontalScroll/HorizontalScroll"
// import { trendingBids, bidwinStats } from "../../dummyData"
import StatsConatiner from "../../components/Stats/StatsConatiner"

const MidHeader = styled.div`
  height: 200px;
  background-image: url(${config.MRBIDNWIN_S3_IMAGE_URL}/mid_banner.svg);
  position: relative;
  z-index: 1;
  background-repeat: no-repeat;
  background-size: cover;
`

const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
`

const DescriptionWrapper = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`

const Title = styled.span`
  font-size: 21px;
  margin-top: 25px;
  margin-bottom: 30px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`

const ProductListContainer = styled.div`
  z-index: 3;
  position: absolute;
  top: 150px;
  display: block;
  width: 90%;
  margin-left: 5%;
  padding-bottom: 10px;
`

const StatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background-color: #1c1d23;
`

const HTBContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
  padding-top: 0;
`

// const TBHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 0 20px;
// `

// const TBTitle = styled.h2`
//   font-family: "montserratRegular";
//   text-align: left;
//   font-size: 16px;
//   font-weight: 500;
//   color: #dfe4ff;
// `

// const SeeAll = styled.span`
//   font-family: "montserratRegular";
//   text-align: left;
//   font-size: 14px;
//   font-weight: 500;
//   color: #fb0e56;
//   cursor: pointer;
// `

// const ImageData = [
//     { id: 1, imgUrl: "../../../images/bg2.jpg", type: "image"},
//     { id: 2, imgUrl: "../../../images/bg4.jpg", type: "image"},
// ];

// const ProductData = [
// 	{
//         "offerId" : 371,
//         "offerImageUrl" : "https://images-na.ssl-images-amazon.com/images/I/51kGUzbPUcL.jpg",
//         "offerTitle" : "Redmi Note 5 Pro",
//         "offerTimeLeft" : "35013",
//         "offerTotalTime" : "257100",
//         "offerDescription" : "4 GB RAM | 64 GB ROM | Expandable Upto 128 GB\r\n5.99 inch Full HD+ Display\r\n12MP + 5MP Dual Rear Camera | 20MP Front Camera\r\n4000 mAh Li Polymer Battery\r\nQualcomm Snapdragon 636 Processor",
//         "price" : "14999",
//         "currentBids" : [ "00.17" ],
//         "startDateTime" : "Auction starts at 10/09/2018 21:05",
//         "isActiveOffer" : true,
//         "auctionStatus" : "UPCOMING"
//     },
//     {
//         "offerId" : 3788,
//         "offerImageUrl" : "https://images-na.ssl-images-amazon.com/images/I/810AsuFzAOL._SL1200_.jpg",
//         "offerTitle" : "JBL Go 2",
//         "offerTimeLeft" : "86133",
//         "offerTotalTime" : "172800",
//         "offerDescription" : "Wirelessly stream high-quality sound \r\nThe IPX7 waterproof \r\nEnjoy crystal clear conference calls\r\nAux in - if Bluetooth is not available",
//         "price" : "2850",
//         "currentBids" : [ ],
//         "startDateTime" : "Auction starts at 12/09/2018 10:42",
//         "isActiveOffer" : true,
//         "auctionStatus" : "UPCOMING"
//     },
//     {
//         "offerId" : 374,
//         "offerImageUrl" : "https://images-na.ssl-images-amazon.com/images/I/51Jy-N1RieL._SL1000_.jpg",
//         "offerTitle" : "Skullcandy Jib Headset with mic",
//         "offerTimeLeft" : "26013",
//         "offerTotalTime" : "86400",
//         "offerDescription" : "Jib offers Supreme Sound technology which produces powerful, dynamic sound across all types of music\r\nThree ear gels of different sizes help you find that perfect fit for blocking noise out and keeping your music in\r\nTalk hands free ",
//         "price" : "999",
//         "currentBids" : [ ],
//         "startDateTime" : "Auction starts at 12/09/2018 18:00",
//         "isActiveOffer" : true,
//         "auctionStatus" : "UPCOMING"
//     },
//     {
//         "offerId" : 368,
//         "offerImageUrl" : "https://getdatagenie.com/img/lenovo k8 plus (1).png",
//         "offerTitle" : "Lenovo K8 Plus",
//         "offerTimeLeft" : null,
//         "offerTotalTime" : null,
//         "offerDescription" : "3 GB RAM | 32 GB ROM | Expandable Upto 128 GB\r\n5.2 inch Full HD Display\r\n13MP + 5MP Dual Rear Camera | 8MP Front Camera\r\n4000 mAh Battery",
//         "price" : "9999",
//         "currentBids" : null,
//         "startDateTime" : "10/Sep/2018",
//         "isActiveOffer" : false,
//         "auctionStatus" : "UPCOMING"
//     },
// ]

class Auctions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      auctionStatus: "ACTIVE",
    }
    this.loadData = this.loadData.bind(this)
    this.onImageSelect = this.onImageSelect.bind(this)
    this.handleAuctionState = this.handleAuctionState.bind(this)
    this.getBtnClassName = this.getBtnClassName.bind(this)
    this.getBorderClassName = this.getBorderClassName.bind(this)
    this.bidClickHanlder = this.bidClickHanlder.bind(this)
    this.showPopup = this.showPopup.bind(this)
  }

  componentWillMount() {
    this.props.setHeaderTitle(null)
    this.loadData()
    console.log("me checking data", this.props.data)
  }

  componentWillUnmount() {
    const { removeData, uniqueId } = this.props
    removeData({
      uniqueId,
    })
  }

  loadData() {
    console.log("offers Auctions load data")
    const { fetchData, uniqueId, saveData } = this.props
    fetchData({
      uniqueId,
      method: "GET",
      uri: `/offers`,
      onSuccess: (res) => {
        setTimeout((_) => {
          this.showPopup()
        }, 2000)
        saveData(res)
      },
    })
  }

  showPopup() {
    const newUser = Storage.get("newUser")
    let host = window.location.hostname
    let subDomain = host.split(".")[0]
    console.log(" AUCTION SUB APP ", subDomain)
    if (
      Cookie.get("COVID_POPUP") === "1" &&
      newUser != "true" &&
      config.COVID_POPUP_DOMAIN.includes(subDomain)
    ) {
      console.log("COVID ALERT 1 ")
      this.props.showPopup({
        renderComponent: () => (
          <CovidAlertPopup t={this.props.t} hidePopup={this.props.hidePopup} />
        ),
        showPopup: true,
      })
      event({
        category: "Home Page",
        action: "Covid Alert Popup",
      })
      Cookie.set("COVID_POPUP", "2")
      console.log("COVID POPUP ", Cookie.get("COVID_POPUP"))
    }

    const freeBids = Cookie.get("freeBids")
    if (newUser && newUser === "true") {
      this.props.showPopup({
        renderComponent: () => (
          <FreeBidPopup
            t={this.props.t}
            count={freeBids}
            hidePopup={this.props.hidePopup}
          />
        ),
        showPopup: true,
      })
      event({
        category: "Home Page",
        action: "Free Bid Popup",
      })
    }
  }

  onImageSelect(x, y) {
    // console.log("xy-->>",x,y)
  }

  handleAuctionState(state, label) {
    this.setState({
      auctionStatus: state,
    })
    event({
      category: "Home Page",
      action: label,
    })
  }

  getBtnClassName(status) {
    if (status === "ACTIVE") {
      return {
        liveClassName: "btn_active",
        upcomingClassName: "btn_inactive",
      }
    }
    return {
      upcomingClassName: "btn_active",
      liveClassName: "btn_inactive",
    }
  }

  getBorderClassName(index, len, isEven) {
    if (isEven) {
      if (index === len - 1) {
        return "bottom_left_border"
      } else if (index === len) {
        return "bottom_right_border"
      }
    } else {
      if (len === 1) return "all_border"
      if (index === len - 1) {
        return "bottom_right_border"
      } else if (index === len) {
        return "bottom_left_border bottom_right_border"
      }
    }
  }

  // checkStatus(data = {}) {
  //   if (data.auctionStatus === "ACTIVE") {
  //     this.props.history.push(
  //       `/play/product-details/${replaceWithSymbol(data.offerTitle)}/${
  //         data.offerId
  //       }`
  //     )
  //     event({
  //       category: "Home Page",
  //       action: "Place Bid",
  //     })
  //   } else if (data.auctionStatus === "UPCOMING") {
  //     this.props.showToast({
  //       text: i18n.t("upcomingAuction"),
  //       variant: "warning",
  //     })
  //   }
  // }

  bidClickHanlder(offerTitle, offerId) {
    this.props.history.push(
      `/play/product-details/${replaceWithSymbol(offerTitle)}/${offerId}`
    )
    event({
      category: "Home Page",
      action: "Place Bid",
    })
  }

  render() {
    console.log("Auctions props -->>", this.props)
    let { data, theme } = this.props
    const { auctionStatus } = this.state
    if (!data) {
      return null
    } else if (data.error) {
      return <span>{data.error}</span>
    }

    const { liveClassName, upcomingClassName } = this.getBtnClassName(
      auctionStatus
    )
    const auction = filter(
      get(data, "data.auctionDetailsDTO.auction", []),
      (_) => {
        return _.auctionStatus === auctionStatus
      }
    )

    console.log("auction me", auction)
    console.log("data 11", data)
    console.log("data.data 11", data.data)
    const auctionBids =
      data &&
      data.data &&
      data.data.auctionDetailsDTO &&
      data.data.auctionDetailsDTO.auction
        ? data.data.auctionDetailsDTO.auction
        : []
    // const trendingBids = auctionBids.filter((fl) => fl.isTrending === true)
    // const trendingBids = auctionBids.filter((fl) => fl.isDaily || fl.isTrending || fl.isWeekly)
    
    // const trendingBids = auctionBids.filter((fl) => fl.auctionStatus === ACTIVE)
    
    //const trendingBids = auctionBids.filter((fl) => fl.isWeekly === true)
    const allbidIsactive = auctionBids.filter((fl) => fl.isActiveOffer === "true")


  
    console.log("auctionBids", auctionBids)
    const bannerData = get(data, "data.bannerResources", [])
    console.log("bannerData", bannerData)
    // const bannerData2 = get(data, "data.bannerResources", [])
    // const combineData = bannerData.concat(bannerData2)
    // console.log("combineData", combineData)
    // const customData = [
    //   {
    //     actionUrl: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/hero-banner.png`,
    //     resourceUrl: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/hero-banner.png`,
    //     type: "IMAGE",
    //   },
    //   ...combineData,
    // ]
    // console.log("customData", customData)
    const len = auction.length
    const isEven = len % 2 === 0
    return (
      <div
        className='container_56'
        style={{ backgroundColor: theme.secondaryColor }}
      >
        {!isEmpty(bannerData) && (
          <CarouselView
            data={bannerData}
            onSelect={this.onImageSelect}
            maxHeight={"175px"}
            share={false}
          />
        )}
        {/* <div
          style={{
            backgroundColor: "#1c1d23",
            position: "relative",
            paddingTop: "10px",
          }}
        >
          <TBHeader>
            <TBTitle>Trending Bids</TBTitle>
            <SeeAll
              onClick={() => this.props.history.push("/play/trending-bids")}
            >
              SEE ALL
            </SeeAll>
          </TBHeader> */}
        {allbidIsactive && allbidIsactive.length > 0 && (
          <HorizontalScroll
         //   title='Trending Bids'
         title='Live Bids'
            seeAllHandler={() =>
              this.props.history.push({
                pathname: "/play/trending-bids",
                state: { screen: "auctions" },
              })
            }
            //bidsType='isWeekly'
            bids={allbidIsactive}
            onClick={this.bidClickHanlder}
          />
        )}
        
        {/* </div> */}
        <div style={{ padding: "20px", backgroundColor: theme.secondaryColor }}>
          <Testimonial theme={theme} />
        </div>
        <StatsConatiner theme={theme} />
        <HTBContainer>
          <ExpenisonPanelView
            title={i18n.t("HowToBid")}
            readEvent='How To Bid Read'
            unReadEvent='How To Bid UnRead'
            theme={theme}
          >
            {theme.howToBidImages && <HowBid theme={theme} />}
          </ExpenisonPanelView>
        </HTBContainer>
        {/* <MidHeader>
          <DescriptionWrapper>
            <Title className='montserratSemiBold'>
              {i18n.t("HeaderMessage")}
            </Title>
            <BtnContainer>
              <PrimaryButton
                label='Live'
                className={liveClassName}
                style={{ marginRight: 15 }}
                onClick={() => this.handleAuctionState("ACTIVE", "Live")}
              />
              <PrimaryButton
                label='Upcoming'
                className={upcomingClassName}
                onClick={() => this.handleAuctionState("UPCOMING", "Upcoming")}
              />
            </BtnContainer>
          </DescriptionWrapper>

          <ProductListContainer>
            <div className='product_list text-center'>
              {auction.map((data, index) => {
                const boderClass = this.getBorderClassName(++index, len, isEven)
                return (
                  <ProductCard
                    key={data.offerId}
                    boderClass={boderClass}
                    title={data.offerTitle}
                    imgUrl={data.offerImageUrl}
                    price={data.price}
                    date={data.startDateTime}
                    live={data.auctionStatus === "ACTIVE"}
                    onClick={() => this.bidClickHanlder(data)}
                  />
                )
              })}
            </div>
            <ExpenisonPanelView
              title={i18n.t("HowToBid")}
              readEvent='How To Bid Read'
              unReadEvent='How To Bid UnRead'
            >
              <HowBid />
            </ExpenisonPanelView>
          </ProductListContainer>
        </MidHeader> */}
      </div>
    )
  }
}

Auctions = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      ;(mapStateToProps.data = state.data[ownProps.uniqueId]),
        (mapStateToProps.theme = state.theme)
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    setHeaderTitle,
    saveData,
    showPopup,
    hidePopup,
  }
)(withRouter(translate("translations")(Auctions)))

export default class AuctionsWrapper extends React.Component {
  componentWillMount() {
    this.uuid = uuid.v4()
  }

  render() {
    return <Auctions {...this.props} uniqueId={this.uuid} />
  }
}



// WEBPACK FOOTER //
// ./src/views/Auctions/index.js